var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxCircleChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "6.26 6.25 35.5 35.5",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6.25a17.75 17.75 0 110 35.5 17.75 17.75 0 010-35.5zM21.2 30.2a.8.8 0 001.13 0l8.57-8.56a.8.8 0 000-1.14l-1.27-1.27a.8.8 0 00-1.13 0l-6.73 6.73-3.33-3.33a.8.8 0 00-1.14 0l-1.27 1.27a.8.8 0 000 1.14l5.17 5.16z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSI2LjI2IDYuMjUgMzUuNSAzNS41Ij48cGF0aCBkPSJNMjQgNi4yNWExNy43NSAxNy43NSAwIDExMCAzNS41IDE3Ljc1IDE3Ljc1IDAgMDEwLTM1LjV6TTIxLjIgMzAuMmEuOC44IDAgMDAxLjEzIDBsOC41Ny04LjU2YS44LjggMCAwMDAtMS4xNGwtMS4yNy0xLjI3YS44LjggMCAwMC0xLjEzIDBsLTYuNzMgNi43My0zLjMzLTMuMzNhLjguOCAwIDAwLTEuMTQgMGwtMS4yNyAxLjI3YS44LjggMCAwMDAgMS4xNGw1LjE3IDUuMTZ6IiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48L3N2Zz4K";
export { SvgCheckboxCircleChecked as ReactComponent };